/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
type AggregatesListing_aggregatesListings$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type aggregatesListingDialog_aggregatesListings$ref: FragmentReference;
declare export opaque type aggregatesListingDialog_aggregatesListings$fragmentType: aggregatesListingDialog_aggregatesListings$ref;
export type aggregatesListingDialog_aggregatesListings = {|
  +totalCount: number,
  +filters: {|
    +places: ?$ReadOnlyArray<{|
      +label: string
    |}>
  |},
  +$fragmentRefs: AggregatesListing_aggregatesListings$ref,
  +$refType: aggregatesListingDialog_aggregatesListings$ref,
|};
export type aggregatesListingDialog_aggregatesListings$data = aggregatesListingDialog_aggregatesListings;
export type aggregatesListingDialog_aggregatesListings$key = {
  +$data?: aggregatesListingDialog_aggregatesListings$data,
  +$fragmentRefs: aggregatesListingDialog_aggregatesListings$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "aggregatesListingDialog_aggregatesListings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AggregatesListingFilters",
      "kind": "LinkedField",
      "name": "filters",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Place",
          "kind": "LinkedField",
          "name": "places",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregatesListing_aggregatesListings"
    }
  ],
  "type": "AggregatesListingConnectionConnection",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '8e9707e64ba6a4b3d68c07581bf5adb8';

export default node;
